import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import React from 'react';
import { setCustomColumnsState } from '../../state/initCustomColumns';
import { Column } from '../../model';
import { CustomColumnsCTAButton } from '../CustomColumnsPanel/CustomColumnsCTAButton';
import type { CustomColumnsDragAndDrop } from './CustomColumnsDragAndDrop';

export interface CustomColumnsBaseProps {
  /**
   * A callback that called when a column checkbox is clicked
   * @param column
   * @param checked
   * @external
   */
  onColumnClick?: (column: Column, checked: boolean) => unknown;
}

export interface CustomColumnsProps extends CustomColumnsBaseProps {
  dragAndDrop?: typeof CustomColumnsDragAndDrop;
}

export function CustomColumns({
  onColumnClick,
  dragAndDrop,
}: CustomColumnsProps) {
  const state = useToolbarCollectionContext();
  return (
    <CustomColumnsCTAButton
      onColumnClick={onColumnClick}
      dragAndDrop={dragAndDrop}
      state={state}
    />
  );
}

CustomColumns.setCustomColumnsState = setCustomColumnsState;
CustomColumns.dragAndDrop = undefined as
  | typeof CustomColumnsDragAndDrop
  | undefined;
CustomColumns.displayName = 'CustomColumns';
